// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation-favorites-alias__edit-favorites-alias-btn {
  margin-right: 5px;
  min-width: 28px;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  color: var(--g-color-text-secondary);
}
.dl-core-navigation-favorites-alias__edit-favorites-alias-btn:hover {
  background: var(--g-color-base-simple-hover);
}
.dl-core-navigation-favorites-alias__lock {
  margin: 2px 5px 0 10px;
  flex: 0 0 16px;
  color: var(--g-color-text-hint);
}
.dl-core-navigation-favorites-alias__name-line {
  display: flex;
  flex: 1 1 auto;
  line-height: 20px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/FavoritesNameWithAliasItem/FavoritesNameWithAliasItem.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAMA,oCAAA;AALR;AACQ;EACI,4CAAA;AACZ;AAKI;EACI,sBAAA;EACA,cAAA;EACA,+BAAA;AAHR;AAMI;EACI,aAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAJR","sourcesContent":[".dl-core-navigation-favorites-alias__edit-favorites-alias-btn {\n  margin-right: 5px;\n  min-width: 28px;\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 4px;\n  color: var(--g-color-text-secondary);\n}\n.dl-core-navigation-favorites-alias__edit-favorites-alias-btn:hover {\n  background: var(--g-color-base-simple-hover);\n}\n.dl-core-navigation-favorites-alias__lock {\n  margin: 2px 5px 0 10px;\n  flex: 0 0 16px;\n  color: var(--g-color-text-hint);\n}\n.dl-core-navigation-favorites-alias__name-line {\n  display: flex;\n  flex: 1 1 auto;\n  line-height: 20px;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
